var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"movecar"},[_c('swiper',{attrs:{"source":_vm.window.source}}),_c('qr-code',{attrs:{"source":_vm.window.source}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }